import React from 'react';
import PodcastPlatforms from '@components/PodcastPlatforms/PodcastPlatforms';
import { graphql } from 'gatsby';

const PodcastPlatformSlice = ({ slice }) => {
  return (
    <>
      <PodcastPlatforms
        apple={slice.primary.apple_podcasts_link?.url}
        spotify={slice.primary.spotify_link?.url}
        youtube={slice.primary.youtube_link?.url}
        type="marketplaceAcademy"
      />
    </>
  );
};

export const query = graphql`
  fragment AcademyLandingDataBodyPodcastPlatform on PrismicAcademyLandingDataBodyPodcastPlatform {
    primary {
      apple_podcast_link {
        url
      }
      spotify_link {
        url
      }
      youtube_link {
        url
      }
    }
  }
  fragment AcademyPostDataBodyPodcastPlatform on PrismicAcademyPostDataBodyPodcastPlatform {
    primary {
      apple_podcast_link {
        url
      }
      spotify_link {
        url
      }
      youtube_link {
        url
      }
    }
  }
`;

export default PodcastPlatformSlice;
